import { nullishFilter, byIdArrayToObj } from '@caresend/utils';
import { hasMutation, customCommit } from '../helpers.js';

const setSupplyItems = (
/** Optional mutations require type casting */
commit, proceduresWithData, store) => {
    /** Procedure supplyItems (only support procedure.supplyItems) */
    let supplyItemsSet = 'N/A';
    let supplyItems;
    if (hasMutation(store, 'supplies/SET_SUPPLY_ITEMS')) {
        const supplyItemsByIdArray = Object.values(proceduresWithData)
            .map((procedure) => procedure.supplyItemsData)
            .filter(nullishFilter);
        const supplyItemsObj = byIdArrayToObj(supplyItemsByIdArray);
        supplyItems = Object.values(supplyItemsObj);
        supplyItemsSet = supplyItems.length;
        customCommit(commit, 'supplies/SET_SUPPLY_ITEMS', supplyItemsObj);
    }
    return { supplyItemsSet, supplyItems };
};

export { setSupplyItems };
